import enReport from './en';
import ruReport from './ru';

export default {
  en: {
    ...enReport,
  },
  ru: {
    ...ruReport,
  },
};
